export const enum AiSuggestionState {
  Preparing = "PREPARING",
  Ready = "READY",
  Filled = "FILLED",
  Canceled = "CANCELED",
  Error = "ERROR"
}
